import React from "react";
import "../styles/FloatingWhatsApp.css";

export default function FloatingWhatsApp() {
  const phoneNumber = "917358798182";

  const message =
    "Hello TANBIO Biomed Genomics Laboratory, I would like to know more about your laboratory services and test booking.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      className="wa-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="fa-brands fa-whatsapp"></i>
    </a>
  );
}